export default __webpack_public_path__ + "static/media/shrutiDlow.ea98bdc5.wav";